module.exports = __webpack_public_path__ + "img/h-1.9174db0c.png";